/**
 *
 *
 * @author Nikola Isakov
 * @date May 29 2019
 */

var util = require('./utils');
var rangeSlider = require('nouislider');

import {debounce} from '../components/custom-lodash';

/**
 * Handle slider input changes.
 * @param priceRangeEl
 * @param priceMinInput
 * @param priceMaxInput
 */

function initRangeSlider(priceRangeEl, priceMinInput, priceMaxInput, callback) {
    var min = parseInt(priceRangeEl.dataset.min);
    var max = parseInt(priceRangeEl.dataset.max);
    var fullRange = max - min;
    var margin = Math.round(fullRange * 0.05);
    var currentMin = parseInt(priceRangeEl.dataset.currentMin);
    var currentMax = parseInt(priceRangeEl.dataset.currentMax);
    var currencyStr = priceRangeEl.dataset.priceFormat;
    var currencyFormat = currencyStr ? util.getCurrencyFormatFromString(currencyStr) : null;
    var range = [currentMin || min, currentMax || max];
    var keydown = false;

    margin = margin > 0 ? margin : 1;

    rangeSlider.create(priceRangeEl, {
        start: range,
        connect: true,
        tooltips: true,
        cssPrefix: 'range-slider-',
        behaviour: 'drag',
        range: {
            min: min,
            max: max
        },
        step: 1,
        margin: margin,
        format: {
            to: function (value) {
                return util.formatLocale(
                    value,
                    currencyFormat.separator,
                    0,
                    currencyFormat.currencyPosition === 'before' ? currencyFormat.currencyChar : '',
                    currencyFormat.currencyPosition === 'after' ? currencyFormat.currencyChar : ''
                );
            },
            from: function (value) {
                return value;
            }
        }
    });

    setTimeout(function () {
        document.querySelectorAll('.range-slider-handle-lower').forEach(function (el) {
            el.setAttribute('aria-label', 'Minimum Price');
        });
        document.querySelectorAll('.range-slider-handle-upper').forEach(function (el) {
            el.setAttribute('aria-label', 'Max Price');
        });
    }, 100);

    priceRangeEl.noUiSlider.on(
        'update',
        debounce(function (values, handle, unencoded, isTap, positions) {
            if (isTap || keydown) return;

            var action = 'refine_price';
            var root = $(priceRangeEl).parents('.refinement-flyin')[0];
            var rangeChanged = false;

            if (handle == 0) {
                priceMinInput.value = unencoded[0];
                rangeChanged = unencoded[0] != range[0];
            } else if (handle == 1) {
                priceMaxInput.value = unencoded[1];
                rangeChanged = unencoded[1] != range[1];
            }

            if (rangeChanged) {
                range = [priceMinInput, priceMaxInput];
                callback(event, range, action, root);
            }
        }, 400)
    );

    // Prevent change fired multiple times when holding arrow keys
    priceRangeEl.addEventListener('keydown', function (event) {
        keydown = true;
    });
    priceRangeEl.addEventListener('keyup', function (event) {
        keydown = false;
    });
}

module.exports = initRangeSlider;
